// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  height: 52px;
  padding: 16px 48px;
  box-sizing: border-box;
  font-size: 16px;
  border: 0;
  border-radius: 5px;
  font-weight: bold;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.5);
  background-color: #ccc;
}
.button span:nth-child(2) {
  margin-left: 8px;
}
.button:hover {
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.3);
  background-color: rgb(211.65, 211.65, 211.65);
}
.button:active {
  box-shadow: 0px 0px 0px -5px rgba(0, 0, 0, 0.3);
  background-color: rgb(196.35, 196.35, 196.35);
}
.button--block {
  width: 100%;
}
.button--small {
  font-size: 12px;
  padding: 8px 16px;
  height: auto;
}
.button--rounded {
  border-radius: 100px;
}
.button--no-wrap {
  white-space: nowrap;
}
.button--icon-only {
  background-color: transparent;
  padding: 0;
  width: 40px;
  height: 40px;
  box-shadow: none;
}
.button--icon-only span {
  line-height: 40px;
}
.button--icon-only:hover {
  background-color: #eee;
}
.button--circle {
  border-radius: 50%;
}
.button--add {
  border-radius: 50%;
  background-color: #0abf53;
  color: white;
  font-size: 70px;
  font-weight: lighter;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  width: 80px;
  height: 80px !important;
}
.button--primary {
  background-color: #0abf53;
  color: #fff;
}
.button--primary:hover {
  background-color: rgb(10.5074626866, 200.6925373134, 87.2119402985);
}
.button--primary:active {
  background-color: rgb(8.9850746269, 171.6149253731, 74.576119403);
}
.button--secondary {
  background-color: white;
  color: #0abf53;
}
.button--secondary:hover {
  background-color: white;
}
.button--secondary:active {
  background-color: rgb(244.8, 244.8, 244.8);
}
.button--solid {
  background-color: transparent;
}
.button--solid:hover {
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.button--error {
  background: #f58686;
  color: #fff;
}
.button--error:not(.button--bordered):hover {
  background: rgb(246.9465648855, 157.5534351145, 157.5534351145);
}
.button--error:not(.button--bordered):active {
  background: rgb(241.106870229, 86.893129771, 86.893129771);
}
.button--bordered {
  border: 2px solid;
  background: #fff;
}
.button--bordered:hover {
  background: #fff;
}
.button--bordered.button--error {
  color: #f58686;
}
.button--grey {
  border: 2px solid #666666;
  color: #666666;
}
.button--green {
  border: 2px solid #0abf53;
  color: #0abf53;
}
.button--red {
  border: 2px solid #f58686;
  color: #f58686;
}
.button--no-padding {
  padding: 0;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,+CAAA;EACA,sBAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,iDAAA;EACA,6CAAA;AAFJ;AAIE;EACE,+CAAA;EACA,6CAAA;AAFJ;AAME;EACE,WAAA;AAJJ;AAME;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAJJ;AAME;EACE,oBAAA;AAJJ;AAME;EACE,mBAAA;AAJJ;AAME;EACE,6BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAJJ;AAKI;EACE,iBAAA;AAHN;AAKI;EACE,sBAAA;AAHN;AAME;EACE,kBAAA;AAJJ;AAME;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mDAAA;EACA,WAAA;EACA,uBAAA;AAJJ;AAOE;EACE,yBCvEY;EDwEZ,WAAA;AALJ;AAOI;EACE,mEAAA;AALN;AAOI;EACE,iEAAA;AALN;AASE;EACE,uBAAA;EACA,cCpFY;AD6EhB;AASI;EACE,uBAAA;AAPN;AASI;EACE,0CAAA;AAPN;AAWE;EACE,6BAAA;AATJ;AAUI;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AARN;AAYE;EACE,mBAAA;EACA,WAAA;AAVJ;AAYI;EACE,+DAAA;AAVN;AAYI;EACE,0DAAA;AAVN;AAaE;EACE,iBAAA;EACA,gBAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAeE;EACE,yBAAA;EACA,cAAA;AAbJ;AAeE;EACE,yBAAA;EACA,cAAA;AAbJ;AAeE;EACE,yBAAA;EACA,cAAA;AAbJ;AAeE;EACE,UAAA;AAbJ;;AAiBA;;EAEE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;AAdF","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.button {\n  height: 52px;\n  padding: 16px 48px;\n  box-sizing: border-box;\n  font-size: 16px;\n  border: 0;\n  border-radius: 5px;\n  font-weight: bold;\n  transition: all 0.3s;\n  cursor: pointer;\n  box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.5);\n  background-color: #ccc;\n\n  span:nth-child(2) {\n    margin-left: 8px;\n  }\n\n  &:hover {\n    box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.3);\n    background-color: lighten(#ccc, 3);\n  }\n  &:active {\n    box-shadow: 0px 0px 0px -5px rgba(0, 0, 0, 0.3);\n    background-color: darken(#ccc, 3);\n  }\n\n  // variations\n  &--block {\n    width: 100%;\n  }\n  &--small {\n    font-size: 12px;\n    padding: 8px 16px;\n    height: auto;\n  }\n  &--rounded {\n    border-radius: 100px;\n  }\n  &--no-wrap {\n    white-space: nowrap;\n  }\n  &--icon-only {\n    background-color: transparent;\n    padding: 0;\n    width: 40px;\n    height: 40px;\n    box-shadow: none;\n    span {\n      line-height: 40px;\n    }\n    &:hover {\n      background-color: #eee;\n    }\n  }\n  &--circle {\n    border-radius: 50%;\n  }\n  &--add {\n    border-radius: 50%;\n    background-color: #0abf53;\n    color: white;\n    font-size: 70px;\n    font-weight: lighter;\n    box-shadow: 0px 3px 6px #00000029;\n    width: 80px;\n    height: 80px !important;\n  }\n\n  &--primary {\n    background-color: $primary-color;\n    color: #fff;\n\n    &:hover {\n      background-color: lighten($primary-color, 2);\n    }\n    &:active {\n      background-color: darken($primary-color, 4);\n    }\n  }\n\n  &--secondary {\n    background-color: white;\n    color: $primary-color;\n\n    &:hover {\n      background-color: lighten(white, 2);\n    }\n    &:active {\n      background-color: darken(white, 4);\n    }\n  }\n\n  &--solid {\n    background-color: transparent;\n    &:hover {\n      border: none;\n      box-shadow: none;\n      background-color: transparent;\n    }\n  }\n\n  &--error {\n    background: #f58686;\n    color: #fff;\n\n    &:not(.button--bordered):hover {\n      background: lighten(#f58686, 5);\n    }\n    &:not(.button--bordered):active {\n      background: darken(#f58686, 10);\n    }\n  }\n  &--bordered {\n    border: 2px solid;\n    background: #fff;\n\n    &:hover {\n      background: #fff;\n    }\n\n    &.button--error {\n      color: #f58686;\n    }\n  }\n  &--grey {\n    border: 2px solid #666666;\n    color: #666666;\n  }\n  &--green {\n    border: 2px solid #0abf53;\n    color: #0abf53;\n  }\n  &--red {\n    border: 2px solid #f58686;\n    color: #f58686;\n  }\n  &--no-padding {\n    padding: 0;\n  }\n}\n\nbutton:disabled,\nbutton[disabled] {\n  border: 1px solid #999999;\n  background-color: #cccccc;\n  color: #666666;\n  pointer-events: none;\n}\n","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
